import React from 'react';
import { FormState } from '../../types';
import { Select } from '../ui/Select';
import { RadioGroup } from '../ui/RadioGroup';
import { Input } from '../ui/Input';
import { Alert } from '../ui/Alert';
import { nonQmProductTypes, processingTypes } from '../../data/mockData';
interface Props {
  state: FormState;
  onChange: (field: keyof FormState, value: any) => void;
}
export function LoanProduct({
  state,
  onChange
}: Props) {
  const isNonQm = state.qmType === 'Non-QM';
  const isDscr = state.nonQmProductType.includes('DSCR');
  const isUwmDscrBypass = state.lender === 'UWM' && isDscr; // Simple mock condition
  const handleQmChange = (val: string) => {
    onChange('qmType', val);
    if (val === 'QM') {
      onChange('nonQmProductType', '');
      onChange('dscrRatio', '');
    }
  };
  return <div className="space-y-8" data-id="element-203">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-204">
        <RadioGroup label="Is this a QM or Non-QM Loan Product?" name="qmType" value={state.qmType} onChange={handleQmChange} options={[{
        label: 'QM',
        value: 'QM'
      }, {
        label: 'Non-QM',
        value: 'Non-QM'
      }]} inline data-id="element-205" />

        {isNonQm && <div className="p-4 bg-slate-50 dark:bg-slate-800/50 rounded-lg border border-slate-200 dark:border-slate-700 space-y-4 col-span-1 md:col-span-2 lg:col-span-4" data-id="element-206">
            <Select label="Non-QM Product Type" value={state.nonQmProductType} onChange={e => onChange('nonQmProductType', e.target.value)} options={nonQmProductTypes} required data-id="element-207" />

            {isDscr && <div className="space-y-4 pt-2" data-id="element-208">
                <Input label="DSCR Ratio" value={state.dscrRatio} onChange={e => onChange('dscrRatio', e.target.value)} placeholder="e.g. 1.25" required data-id="element-209" />

                {isUwmDscrBypass && <Alert variant="info" data-id="element-210">
                    UWM DSCR bypass conditions apply. This is informational only
                    and does not block submission.
                  </Alert>}
              </div>}
          </div>}

        <div className="col-span-1 md:col-span-2 lg:col-span-4 pt-4 border-t border-slate-100 dark:border-slate-700" data-id="element-211">
          <Select label="Processing Type" value={state.processingType} onChange={e => onChange('processingType', e.target.value)} options={processingTypes} required data-id="element-212" />
        </div>
      </div>
    </div>;
}